// src/theme/tokens.js
// Tokens de diseño para el rediseño estético incremental de la app.
// Dos temas: "dark" (operativo/tablet: encargado/operario) y "light" (escritorio:
// ventas/admin/administracion). Cada pantalla migrada elige su modo envolviéndose
// en <ThemeProvider mode="dark|light">. Las pantallas NO migradas no importan nada
// de acá → cero impacto (rollout incremental sin romper nada).

const SHARED = {
  radius: { sm: 8, md: 12, lg: 16, pill: 999 },
  space: { xs: 4, sm: 8, md: 12, lg: 16, xl: 20, xxl: 24 },
  font: {
    xs: "11px", sm: "12px", md: "13px", base: "14px",
    lg: "16px", xl: "18px", xxl: "22px",
  },
  weight: { regular: 500, bold: 700, black: 800 },
};

const dark = {
  mode: "dark",
  color: {
    bg: "#0f172a",
    surface: "#1e293b",
    surfaceAlt: "#111c31",
    border: "#334155",
    borderStrong: "#475569",
    text: "#f8fafc",
    textMuted: "#94a3b8",
    textFaint: "#64748b",
    accent: "#2563eb", accentText: "#ffffff", accentBg: "#17314f", accentOn: "#93c5fd",
    success: "#16a34a", successText: "#ffffff", successBg: "#14532d", successBorder: "#16a34a", successSoft: "#86efac",
    danger: "#dc2626", dangerText: "#ffffff", dangerBg: "#3f1d2b", dangerBorder: "#7f1d1d", dangerSoft: "#fca5a5",
    warning: "#f59e0b", warningText: "#111827", warningBg: "#422006", warningBorder: "#854d0e", warningSoft: "#fcd34d",
    chipBg: "#334155", chipText: "#cbd5e1",
    overlay: "rgba(0,0,0,0.7)",
  },
  shadow: { card: "none", raised: "0 4px 14px rgba(0,0,0,0.35)" },
  ...SHARED,
};

const light = {
  mode: "light",
  color: {
    bg: "#f8fafc",
    surface: "#ffffff",
    surfaceAlt: "#f1f5f9",
    border: "#e2e8f0",
    borderStrong: "#cbd5e1",
    text: "#0f172a",
    textMuted: "#64748b",
    textFaint: "#94a3b8",
    accent: "#2563eb", accentText: "#ffffff", accentBg: "#eff6ff", accentOn: "#1d4ed8",
    success: "#16a34a", successText: "#ffffff", successBg: "#f0fdf4", successBorder: "#86efac", successSoft: "#15803d",
    danger: "#dc2626", dangerText: "#ffffff", dangerBg: "#fef2f2", dangerBorder: "#fecaca", dangerSoft: "#b91c1c",
    warning: "#b45309", warningText: "#ffffff", warningBg: "#fffbeb", warningBorder: "#fde68a", warningSoft: "#b45309",
    chipBg: "#f1f5f9", chipText: "#475569",
    overlay: "rgba(15,23,42,0.45)",
  },
  shadow: { card: "0 1px 3px rgba(0,0,0,0.06)", raised: "0 8px 24px rgba(0,0,0,0.12)" },
  ...SHARED,
};

export const THEMES = { dark, light };
export function getTheme(mode) { return THEMES[mode] || THEMES.dark; }
